function throttle(func, limit) {
  let inThrottle = false;

  return function () {
    if (!inThrottle) {
      // eslint-disable-next-line prefer-rest-params
      func.apply(this, arguments);
      inThrottle = true;

      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}

const scrollToTop = () => {
  const scrollToTopBtn = document.getElementById("scroll-to-top-btn");

  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    const handleScroll = throttle(() => {
      const scrolledFromTop = window.scrollY;

      if (scrolledFromTop > 300) {
        scrollToTopBtn.classList.add("fixed");
      } else {
        scrollToTopBtn.classList.remove("fixed");
      }
    }, 50);

    window.addEventListener("scroll", handleScroll);
  }
};

export default scrollToTop;
